import React from "react";
import styled from "styled-components";
import { OfferStatus, OfferStatusLabels } from "../../constants";

const Badge = styled.span`
	display: inline-block;
	padding: 0.25rem 0.75rem;
	border-radius: 9999px;
	font-size: 0.75rem;
	font-weight: 600;
	color: white;
	background: ${(props) => props.color || "#6b7280"};
`;

const statusColorMap = {
	[OfferStatus.CREATED]: "#3b82f6",
	[OfferStatus.DRAFT]: "#6b7280",
	[OfferStatus.PUBLISHED]: "#10b981",
	[OfferStatus.INACTIVE]: "#f59e0b",
	[OfferStatus.EXPIRED]: "#ef4444",
};

const OfferStatusBadge = ({ status }) => {
	const label = OfferStatusLabels[status] || status;
	const color = statusColorMap[status] || "#6b7280";
	return <Badge color={color}>{label}</Badge>;
};

export default OfferStatusBadge;
